import React, { useEffect, useState, useMemo } from "react";
import jsPDF from "jspdf";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../../Dashboard/Sidebar/Sidebar";
import config from "../../../../config/config";
import Loader from "../../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../../components/Modal/DeleteConfirmation";
import {
  DATA_EXPORT,
  DELETE_MESSAGE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
  CUSTOM_SELECT_DROPDOWN_STYLE,
} from "../../../../common/Constant";
import { toastError, toastSuccess } from "../../../../common/Toast";
import CleanupConfirmationModal from "../../../../components/Modal/CleanupConfirmation";
import SkipbarcodeConfirmationModal from "../../../../components/Modal/barcodesheetmodal";
import { checkUserPermission } from "../../../../common/UserPermission";
import Select from "react-select";
import * as XLSX from "xlsx";
import { Noimage } from "../../../../common/imagePath";
import moment from "moment";
//MUI Table
import { MaterialReactTable } from "material-react-table";
import { Box, Button, MenuItem } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import { Cell } from "jspdf-autotable";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import CommonMatrialReactTableServerSideRender from "../../../../components/Datatable/CommonMatrialReactTableServerSideRender";
import { handleSaveColumnOrder } from "../../../../common/common";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import CommonDatePicker from "../../../../components/DatePicker/CommonDatePicker";
// import { MenuItem } from "@mui/material";
// import { Box, Button } from "@mui/material";
// import FileDownloadIcon from "@mui/icons-material/FileDownload";
// import { toastSuccess } from '../../../../common/Toast';
// import { DELETE_MESSAGE } from '../../../../common/Constant';

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/manage-customers";
let PERMISSION_EDIT = "/manage-customers/:id";
let PERMISSION_DELETE = "delete-customers";
let PERMISSION_MANAGE_DELETED_CUSTOMERS = "/deleted-customers";
let PERMISSION_EXCEL_IMPORT = "/import-excel-customers";
let PERMISSION_EXCEL_EXPORT = "excel-export-customers";
let PERMISSION_CLEANUP_OLD_CUSTOMERS = "cleanup-old-customers";
let PERMISSION_CUSTOM_FIELD_CONFIGURATION = "/custom-field-configuration";
let PERMISSION_CUSTOMER_INTAKE_FORM = "/customer-intake-form";

let PERMISSION_EMAIL_CUSTOMERS = "email-customers";
let PERMISSION_MAILING_LABELS = "mailing-labels-customers";
let PERMISSION_BARCODE_LABELS = "barcode-labels-customers";
let PERMISSION_BARCODE_SHEETS = "barcode-sheets-customers";

const Customers = () => {
  let selectData = [];
  const navigate = useNavigate();
  let pathforpdf = "";
  let selectDatas = [];
  // let excelalldata;
  const token = localStorage.getItem("Token");
  const loginuserid = localStorage.getItem("ID");
  const [perPageSize, setperPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const [state, setState] = useState("");

  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedCustomerCheckboxs, setselectedCustomerCheckbox] = useState("");
  const [selectedCustomerCheckEmails, setselectedCustomerCheckEmails] =
    useState("");
  const [selectedCustomerCheckpathforpdf, setselectedCustomerCheckpathforpdf] =
    useState("");
  const [selectedCustomerBarcodeLabel, setselectedCustomerBarcodeLabel] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);
  const [selectedDataDelete, setSelectedDataDelete] = useState("");

  const options = [
    { label: "All", value: 1 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  //popup on delete
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");

  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const [showDateFilterModal, setShowDateFilterModal] = useState(false);
  const [showaction, setShowAction] = useState(true);
  const [openingbalance, setOpeningBalance] = useState(0);

  const [columnVisibility, setColumnVisibility] = useState({});
  const [columnOrder, setColumnOrder] = useState([]);

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  const handleDateFilterCancel = () => {
    setShowDateFilterModal(false);
  };

  const handleDateFilterConfirm = () => {
    console.log("api call delete");
    const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
    console.log("deleteRequestParam: 12", deleteRequestParam);
    const deleteApiUrl = `${config.customersBaseUrl}/customers/delete`;
    // console.log("deleteApiUrl: ", deleteApiUrl);
    axios
      .post(`${deleteApiUrl}`, deleteRequestParam, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then(() => {
        toastSuccess(SUCCESS_MESSAGE);
        window.location.reload();
        window.location.href = window.location.href;
      });

    setShowDateFilterModal(false);
  };

  //table state
  // const [columnFilters, setColumnFilters] = useState([]);
  // const [globalFilter, setGlobalFilter] = useState('');
  // const [sorting, setSorting] = useState([]);
  // const [pagination, setPagination] = useState({
  //   pageIndex: 0,
  //   pageSize: 25,
  // });

  // const navigate = useNavigate()

  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");
  const Id = localStorage.getItem("ID");

  // Styles
  // const selectStyles = {
  //   // dropdown input css
  //   control: (provided, state) => ({
  //     ...provided,
  //     width: "100%",
  //     height: "40px",
  //     position: "relative",
  //     border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
  //     "&:hover": {
  //       border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
  //     },
  //   }),
  //   // dropdown menu css
  //   menu: () => ({
  //     boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
  //     position: "absolute",
  //     "z-index": "999",
  //     background: "#f8f8f8",
  //     color: "#000",
  //     width: "100%",
  //   }),
  //   // dropdown option css
  //   option: (provided, state) => ({
  //     ...provided,
  //     color: state.isActive ? "#000" : "#000",
  //     backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
  //     "&:hover": {
  //       color: "#000",
  //       backgroundColor: "rgba(255, 159, 67, 0.8)", // change hover color to light orange
  //     },
  //   }),
  // };

  //BARCODE
  const handlebarcodesheet = (pID) => {
    const barcodeRequestParam = pID;
    //   Barcode_Id: pID,
    // };
    localStorage.setItem(
      "BarcodeRequestParam",
      barcodeRequestParam
      // JSON.stringify(barcodeRequestParam)
    );

    getCustomerDetailsForLabelById(barcodeRequestParam);
  };

  const getCustomerDetailsForLabelById = (barcodeRequestParam) => {
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${barcodeRequestParam}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // setFormValues(res.data.ResponseData);
        console.log(res.data);
        console.log(res.data.ResponseData);
      });
  };

  // Get all tag data
  const handleListData = (
    startingdate,
    endingdate,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    setLoading(true);

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
      return {
        columnname: el.id,
        value: el.value,
        id: index + 1,
        // count: el.id==="Supplier"? el.value.length:0, ismultiple: el.id==="Supplier"? 1:0
      };
    });

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";

    axios
      .get(
        `${
          config.customersBaseUrl
        }/customers?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex === -1 ? "" : columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&startdate=${startingdate == undefined ? "" : startingdate}&enddate=${
          endingdate == undefined ? "" : endingdate
        }&loginId=${loginuserid}&locationid=${localStorage.getItem("Location")}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res, "selmonn");
        const FilterData = res.data.ResponseData?.list?.map((el) => ({
          ...el,
          QuickBookOpenBalance: Number(el.QuickBookOpenBalance),
          // Location : String(el.Location)
        }));
        setData(FilterData);
        setRowCount(res.data.ResponseData?.list[0].TotalRecord);

        setColumnOrder(res.data.ResponseData?.ColumnOrder.split(","));

        const keysToSetFalse = res.data.ResponseData?.ColumnsHide || "";

        // Create default object with all values set to true
        const obj = columns.reduce((acc, item) => {
          acc[item.accessorKey] = true;
          return acc;
        }, {});

        // Comma-separated string of keys to set to false

        // Convert the string to an array and set the corresponding keys in the object to false
        keysToSetFalse.split(",").forEach((key) => {
          if (obj.hasOwnProperty(key)) {
            obj[key] = false;
          }
        });

        setColumnVisibility(obj);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  // pdf make onclick

  // const handleRowSelected = (e) => {
  //   if (e.selectedRows.length > 0) {
  //     // for get detlais form id
  //     setSelectedRows(e.selectedRows.map((x) => x.Id));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Id);
  //     const selectedCustomerCheckboxIDs =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     const selectedDataDelete =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setSelectedDataDelete(selectedDataDelete);
  //     setselectedCustomerCheckbox(selectedCustomerCheckboxIDs);
  //     const datasplitforpath = selectedCustomerCheckboxIDs?.split(",");
  //     pathforpdf = datasplitforpath?.join("~");
  //     setselectedCustomerCheckpathforpdf(pathforpdf);
  //     console.log("Datasasasa", pathforpdf);

  //     // get emails of selectdids
  //     setSelectedRows(e.selectedRows.map((x) => x.Email));
  //     selectData[currentPage] = e.selectedRows.map((x) => x.Email);
  //     const selectedCustomerCheckboxEmails =
  //       selectData.length > 0 ? selectData[currentPage].toString() : "";
  //     setselectedCustomerCheckEmails(selectedCustomerCheckboxEmails);
  //     console.log(selectedCustomerCheckboxEmails);
  //   }
  // };

  // const handleDeletePopup = (pID) => {
  //   console.log(pID, "pid==>");
  //   const deleteRequestParam = {
  //     id: pID,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   // setShowDateFilterModal(true);
  //   // setShowAction(false);
  //   setDeleteModalOpen(true)
  // };

  const handleDeletePopup = (id, qbId, rows, field, openingbalance) => {
    console.log(id, "id");
    // console.log(rows.map((el) => el.original), "rows231")
    let data;
    let qbdata;
    if (field == "multipleRowInactive") {
      data = rows.map((el) => el.original.Id).join(",");
      qbdata = rows.map((el) => el.original.QuickbookID).join(",");
    } else {
      data = id;
      qbdata = qbId.toString();
      setOpeningBalance(openingbalance);
    }

    const deleteRequestParam = {
      id: data,
      loginuserid: loginuserid,
      QuickbookID: qbdata,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
    // setShowDateFilterModal(true);
    // setShowAction(false);
    setDeleteModalOpen(true);
  };

  const handleCustomerEmails = (id, rows, field) => {
    let a = rows.map((el) => el.original.Email);
    console.log(a, "aaa");
    selectData[currentPage] = rows?.map((x) => x.original.Email);
    const selectedCustomerCheckboxEmails =
      selectData.length > 0 ? selectData[currentPage].toString() : "";
    setselectedCustomerCheckEmails(selectedCustomerCheckboxEmails);
  };

  console.log(selectedCustomerCheckEmails, "selectedCustomerCheckEmails");

  // const contextActions = useMemo(() => {
  //   // for handling barcode label
  //   const handlebarcode = (pID) => {
  //     const barcodeRequestParam = pID;

  //     localStorage.setItem(
  //       "BarcodeRequestParam",
  //       barcodeRequestParam
  //       // JSON.stringify(barcodeRequestParam)
  //     );
  //   };

  //   // For handle pdf
  //   const handlepdf = () => {
  //     console.log("Enyer", selectedCustomerCheckboxs);
  //     axios
  //       .get(
  //         `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${selectedCustomerCheckboxs}`,
  //         {
  //           headers: {
  //             "Content-Type": "application/json;charset=UTF-8",
  //             Authorization: token,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         const doc = new jsPDF();

  //         let position = 0;
  //         for (let i = 0; i < res.data.ResponseData.length; i++) {
  //           console.log(res.data.ResponseData.length);
  //           position = position + 10;
  //           doc.setFontSize(10);

  //           doc.text(
  //             `FirstName: ${res.data.ResponseData[i].FirstName}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(
  //             `LastName: ${res.data.ResponseData[i].LastName}`,
  //             10,
  //             position
  //           );
  //           position = position + 10;
  //           doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
  //           position = position + 10;
  //           doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
  //           position = position + 10;
  //           doc.text(
  //             `Address1: ${res.data.ResponseData[i].Address1}`,
  //             10,
  //             position
  //           );
  //           console.log(res.data.ResponseData);

  //           position = position + 10;

  //           if ((i + 1) % 4 == 0) {
  //             doc.addPage();
  //             position = 0;
  //           } else if (i == res.data.ResponseData.length - 1) {
  //           }
  //         }
  //         //   doc.deletePage(Last);
  //         doc.save(`Customers_mailing_label${Date.now()}.pdf`);
  //         setState({ data: res.data.ResponseData });
  //       });
  //   };

  //   return (
  //     <>
  //       <div className="row px-2 ">
  //         <div className="col-12 align-self-center">
  //           {checkUserPermission(PERMISSION_EMAIL_CUSTOMERS) ? (
  //             <a href={"mailto:" + selectedCustomerCheckEmails}>
  //               <button type="button" className="btn btn-dark btn-sm ">
  //                 <i className="fa fa-envelope fa-sm" /> E-mail
  //               </button>
  //             </a>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>

  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* <a href={"/mailing_labels/" + selectedCustomerCheckpathforpdf}> */}
  //           {checkUserPermission(PERMISSION_MAILING_LABELS) ? (
  //             <button
  //               type="button"
  //               className="btn btn-dark btn-sm"
  //               title="MailingLabels"
  //               onClick={handlepdf}
  //             >
  //               <i className="fa fa-envelope-square fa-sm" /> Mailing-Labels
  //             </button>
  //           ) : (
  //             ""
  //           )}
  //           {/* </a> */}
  //         </div>
  //       </div>

  //       <div className="row px-2 ">
  //         <div className="col-12 align-self-center">
  //           {checkUserPermission(PERMISSION_BARCODE_LABELS) ? (
  //             <a href={"/customer-barcode-label"}>
  //               <button
  //                 type="button"
  //                 className="btn btn-dark btn-sm"
  //                 onClick={handlebarcode(selectedCustomerCheckboxs)}
  //               >
  //                 <i className="fa fa-envelope-square fa-sm" /> Barcode Labels
  //               </button>
  //             </a>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>

  //       <div className="row px-2">
  //         <div className="col-12 align-self-center">
  //           {/* () => setLgShow(true) */}
  //           {checkUserPermission(PERMISSION_BARCODE_SHEETS) ? (
  //             <button
  //               type="button"
  //               className="btn btn-dark btn-sm"
  //               data-bs-toggle="modal"
  //               data-bs-target="#BarcodeSheetModal"
  //               title="MailingLabels"
  //               onClick={() => handlebarcodesheet(selectedCustomerCheckboxs)}
  //             >
  //               <i className="fa fa-envelope-square fa-sm" /> Barcode-Sheets
  //             </button>
  //           ) : (
  //             ""
  //           )}
  //         </div>
  //       </div>
  //       <div className="row px-2">
  //         {checkUserPermission(PERMISSION_DELETE) && (
  //           <button
  //             type="button"
  //             className="btn btn-danger btn-sm pull-left "
  //             data-bs-toggle="modal"
  //             data-bs-target="#DeleteConfirmationModal"
  //             onClick={() => handleDeletePopup()}
  //           >
  //             <i className="fa fa-trash fa-sm" /> Delete Selected
  //           </button>
  //         )}
  //       </div>
  //     </>
  //   );
  // }, [data, selectedRows, toggleCleared]);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };

  const handleSearchAccordingToDate = () => {
    handleListData(
      startingDate,
      endingDate,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  };

  useEffect(() => {
    // console.log(quickBookOptions?.value,"value")
    if (quickBookOptions?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    // else if (quickBookOptions?.value == 2) {
    //   setStartingDate(customStartingDate);
    //   setEndingDate(customEndingDate);
    // }
    // Last Week Condition
    else if (quickBookOptions?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (quickBookOptions?.value == 4) {
      const currentWeekStartDate = moment()
        .startOf("week")
        .format("YYYY-MM-DD");
      const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

      setStartingDate(currentWeekStartDate);
      setEndingDate(currentWeekEndDate);
    }
    // Last Month Condition
    else if (quickBookOptions?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    //currentmonth
    else if (quickBookOptions?.value == 6) {
      const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
      const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(currentFirstDate);
      setEndingDate(currentLastDate);
    } else if (quickBookOptions?.value == 2) {
      setStartingDate("");
      setEndingDate("");
    }
  }, [quickBookOptions]);

  // console.log(startingDate,endingDate,"startandend")

  useEffect(
    () => {
      // if (quickBookOptions?.value !== 2) {
      handleListData(
        // 1,
        // perPageSize,
        // searchtext,
        // sortingId,
        // sortingDirection,
        startingDate,
        endingDate,
        columnFilters,
        globalFilter,
        pagination,
        sorting
      );
    },
    // }
    [quickBookOptions, columnFilters, globalFilter, pagination, sorting]
  );

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "Id",
      size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT)
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight: "700",
                textDecoration: "underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() => navigate(`/manage-customers/${row.original.Id}`)}
            >
              {row.original.Id}
            </Box>
          )
        : null,
      filterFn: "contains",
    },
    {
      header: "Created On",
      accessorKey: "CreatedDate",
      Cell: ({ row }) =>
        moment(row.original.CreatedDate).format("MM/DD/YYYY h:mm A"),
    },
    {
      header: "Company Name",
      accessorKey: "CompanyName",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() => navigate(`/manage-customers/${row.original.Id}`)}
        >
          {row.original.CompanyName}
        </Box>
      ),
    },
    {
      header: "User Login",
      accessorKey: "personid",
    },
    {
      header: "Name",
      accessorKey: "Name",
    },
    {
      header: "E-Mail",
      accessorKey: "Email",
      Cell: ({ row }) => (
        <p className="word-break-data" title={row.original.Email}>
          {row.original.Email}
        </p>
      ),
    },
    {
      header: "Phone Number",
      accessorKey: "PhoneNumber",
      size: 120,
    },
    {
      header: "QB SyncStatus",
      accessorKey: "SyncStatusName",
      size: 100,

      Cell: ({ row }) =>
        row.original.SyncStatusName == "Completed" ? (
          <Box
            // class="text-warning word-break-data"
            // to={`/manage-suppliers/${row.original.SupplierId}`}
            component="span"
            sx={(theme) => ({
              // backgroundColor: '#E8F7F5',
              borderRadius: "0.3rem",
              color: "var(--success-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : row.original.SyncStatusName == "Failed" ? (
          <Box
            component="span"
            sx={(theme) => ({
              //  backgroundColor: '#FEF7E2',
              borderRadius: "0.3rem",
              color: "var(--error-main-color)",
              maxWidth: "9ch",
              p: "0.3rem",
              fontWeight: "bold",
            })}
          >
            {row.original.SyncStatusName}
          </Box>
        ) : (
          ""
        ),
      // enableGrouping: false, //do not let this column be grouped
    },
    {
      header: "Begning Balance",
      accessorKey: "Openingbalance",
      size: 100,
      Cell: ({ row }) => parseFloat(row.original.Openingbalance).toFixed(2),
    },
    {
      header: "Open Balance",
      accessorKey: "OpenBalance",
      size: 100,
      Cell: ({ row }) => parseFloat(row.original.OpenBalance).toFixed(2),
    },
    // {
    //   header: "Credit Balance",
    //   accessorKey: "Balance",
    //   size: 100,
    //   Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
    // },
    {
      header: "Profile",
      accessorKey: "Image",
      size: 100,
      Cell: ({ row }) => (
        <>
          <a href={row.original.Image} target="_blank">
            <img
              src={row.original.Image}
              alt="Profile Image"
              style={{
                maxWidth: "30px",
                maxHeight: "70px",
                margin: "5px",
              }}
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage;
              }}
            ></img>
          </a>
        </>
      ),
    },
    {
      header: "Is Ecom User",
      accessorKey: "IsEcommerceUser",
      size: 100,
    },
    {
      header: "QuickBook OpenBalance",
      accessorKey: "QuickBookOpenBalance",
      Cell: ({ row }) =>
        parseFloat(
          row.original.QuickBookOpenBalance == null
            ? ""
            : row.original.QuickBookOpenBalance
        ).toFixed(2),
      // size: 120,
    },
  ]);
  // >>>>>>> Bhaskar_DataTableModificationFeedback_06-10-2023

  // enableGrouping: false, //do not let this column be grouped
  //   },

  //   {
  //     header: "Phone Number",
  //     accessorKey: "PhoneNumber",
  //   },
  //   {
  //     header: "Profile",
  //     accessorKey: "Image",
  //     Cell: ({ row }) => (
  //       <>
  //         <a href={row.original.Image} target="_blank">
  //           <img
  //             src={row.original.Image}
  //             alt="Profile Image"
  //             style={{
  //               maxWidth: "30px",
  //               maxHeight: "70px",
  //               margin: "5px",
  //             }}
  //             onError={(e) => {
  //               e.target.onerror = null;
  //               // style={{
  //               //   maxWidth: "70px",
  //               //   maxHeight: "70px",
  //               //   margin: "5px",
  //               // }}
  //               e.target.src = Noimage;
  //             }}
  //           ></img>
  //         </a>
  //       </>
  //     ),

  //     // enableGrouping: false, //do not let this column be grouped
  //   },

  //   {
  //     header: "Opening Balance",
  //     accessorKey: "OpeningBalance",
  //     Cell: ({ row }) => parseFloat(row.original.Openingbalance).toFixed(2),
  //   },

  //   {
  //     header: "Account Balance",
  //     accessorKey: "AccountBalance",
  //     Cell: ({ row }) => parseFloat(row.original.Balance).toFixed(2),
  //   },
  //   {
  //     header: "Created On",
  //     accessorKey: "CreatedOn",
  //     Cell: ({ row }) => formatDate(row.original.CreatedDate),
  //   },
  // ]);

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  const handleExcelExport = () => {
    setLoading(true);
    axios
      .post(
        `${config.customersBaseUrl}/customers/exportexcel`,
        {
          filtertext: searchtext,
          ordercolumn: sortingId,
          currentorder: sortingDirection,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        // console.log("res ==> ", res.data.ResponseData);

        const data =
          res.data.ResponseData.length > 0 ? res.data.ResponseData : [];

        // Create a new workbook
        const workbook = XLSX.utils.book_new();

        // Convert the data to a worksheet
        const worksheet = XLSX.utils.json_to_sheet(data);

        // Add the worksheet to the workbook
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        // Save the workbook as an Excel file
        XLSX.writeFile(workbook, `customers_details_.xlsx`);
        setLoading(false);
      })
      .catch((err) => {
        toastError(ERROR_MESSAGE);
        setLoading(false);
      });
  };

  // store checkbox checked values to hide or show columns
  // const handleExcelExport = () => {
  //   setLoading(true);
  //   axios({
  //     url: `${config.customersBaseUrl}/customers/exportexcel`,
  //     method: "POST",
  //     data: {
  //       filtertext: searchtext,
  //       ordercolumn: sortingId,
  //       currentorder: sortingDirection,
  //     },
  //     headers: {
  //       Authorization: token,
  //     },
  //     responseType: "blob", // set response type to blob
  //   })
  //     .then((res) => {
  //       const url = window.URL.createObjectURL(new Blob([res.data]));
  //       const link = document.createElement("a");
  //       link.href = url;
  //       link.setAttribute("download", "data.xlsx"); // set file name
  //       document.body.appendChild(link);
  //       link.click();
  //       toastSuccess(DATA_EXPORT);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       toastError(ERROR_MESSAGE);
  //       setLoading(false);
  //     });
  // };

  // function handleCheckboxChange(columnName) {
  //   if (hiddenColumns.includes(columnName)) {
  //     setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
  //   } else {
  //     setHiddenColumns([...hiddenColumns, columnName]);
  //   }
  // }

  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  // const handleChangeCustomStartingDate = (event) => {
  //   console.log("event starting ==> ", event.target.value);
  //   setCustomStartingDate(event.target.value);
  //   setStartingDate(event.target.value);
  // };

  const handleChangeCustomStartingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setCustomStartingDate(selectedDate);
      setStartingDate(selectedDate);
    }
  };

  // const handleChangeCustomEndingDate = (event) => {
  //   // console.log("event ending ==> ", event.target.value);
  //   setCustomEndingDate(event.target.value);
  //   setEndingDate(event.target.value);
  // };

  const handleChangeCustomEndingDate = (selectedDate) => {
    if (selectedDate && selectedDate.length > 0) {
      // const datetime =
      //   moment(selectedDate[0]).format("YYYY-MM-DDT00:00:00.000") + "Z";
      // const settime = moment(datetime).format("YYYY-MM-DD");
      // console.log(settime, "settime");
      setCustomEndingDate(selectedDate);
      setEndingDate(selectedDate);
    }
  };

  const handleQuickBookChange = (fieldName, event) => {
    // console.log("Value ==> ", event);
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      var currentDateForLastWeek = new Date();
      // console.log("currentDateForLastWeek ==> ", currentDateForLastWeek);
      // Set the date to the start of the current week (Sunday)
      var startOfWeekForLastWeek = new Date(
        currentDateForLastWeek.setDate(
          currentDateForLastWeek.getDate() - currentDateForLastWeek.getDay()
        )
      );
      // console.log("startOfWeekForLastWeek ==> ", startOfWeekForLastWeek);

      // Set the date to the end of the last week (Saturday)
      var endOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(startOfWeekForLastWeek.getDate() - 1)
      );
      // console.log("endOfLastWeekForLastWeek ==> ", endOfLastWeekForLastWeek);

      // Set the date to the start of the last week (Sunday)
      var startOfLastWeekForLastWeek = new Date(
        startOfWeekForLastWeek.setDate(endOfLastWeekForLastWeek.getDate() - 6)
      );

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForLastWeek = startOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      var endDateStringForLastWeek = endOfLastWeekForLastWeek
        .toISOString()
        .slice(0, 10);
      // Output the results
      // console.log(
      //   "Last week started on " +
      //     startDateStringForLastWeek +
      //     " and ended on " +
      //     endDateStringForLastWeek
      // );
      setStartingDate(startDateStringForLastWeek);
      setEndingDate(endDateStringForLastWeek);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      var currentDateForCurrentWeek = new Date();
      // console.log("currentDateForCurrentWeek ==> ", currentDateForCurrentWeek);

      // Set the date to the start of the current week (Sunday)
      var startOfWeekForCurrentWeek = new Date(
        currentDateForCurrentWeek.getTime() -
          currentDateForCurrentWeek.getDay() * 24 * 60 * 60 * 1000
      );
      // console.log("startOfWeekForCurrentWeek ==> ", startOfWeekForCurrentWeek);

      // Set the date to the end of the current week (Saturday)
      var endOfWeekForCurrentWeek = new Date(
        startOfWeekForCurrentWeek.getTime() + 6 * 24 * 60 * 60 * 1000
      );
      // console.log("endOfWeekForCurrentWeek ==> ", endOfWeekForCurrentWeek);

      // Format the dates as strings in the YYYY-MM-DD format
      var startDateStringForCurrentWeek = startOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      var endDateStringForCurrentWeek = endOfWeekForCurrentWeek
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   "Current week started on " +
      //     startDateStringForCurrentWeek +
      //     " and ended on " +
      //     endDateStringForCurrentWeek
      // );

      setStartingDate(startDateStringForCurrentWeek);
      setEndingDate(endDateStringForCurrentWeek);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      // Get today's date
      const todayForLastMonth = new Date();

      // Get the first day of the current month
      const firstDayCurrentMonthForLastMonth = new Date(
        todayForLastMonth.getFullYear(),
        todayForLastMonth.getMonth(),
        1
      );

      // Get the last day of the previous month
      const lastDayPrevMonthForLastMonth = new Date(
        firstDayCurrentMonthForLastMonth.getTime() - 1
      );

      // Get the starting date of the previous month
      const firstDayPrevMonthForLastMonth = new Date(
        lastDayPrevMonthForLastMonth.getFullYear(),
        lastDayPrevMonthForLastMonth.getMonth(),
        1
      );

      // Format the starting and ending dates of the previous month as yyyy-mm-dd
      const startDateFormattedForLastMonth = firstDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForLastMonth = lastDayPrevMonthForLastMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of last month: ${startDateFormattedForLastMonth}`
      // );
      // console.log(`Ending date of last month: ${endDateFormattedForLastMonth}`);
      setStartingDate(startDateFormattedForLastMonth);
      setEndingDate(endDateFormattedForLastMonth);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      // Get today's date
      const todayForCurrentMonth = new Date();

      // Get the first day of the current month
      const firstDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth(),
        1
      );

      // Get the last day of the current month
      const lastDayOfMonthForCurrentMonth = new Date(
        todayForCurrentMonth.getFullYear(),
        todayForCurrentMonth.getMonth() + 1,
        0
      );

      // Format the starting and ending dates of the current month as yyyy-mm-dd
      const startDateFormattedForCurrentMonth = firstDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);
      const endDateFormattedForCurrentMonth = lastDayOfMonthForCurrentMonth
        .toISOString()
        .slice(0, 10);

      // console.log(
      //   `Starting date of current month: ${startDateFormattedForCurrentMonth}`
      // );
      // console.log(
      //   `Ending date of current month: ${endDateFormattedForCurrentMonth}`
      // );
      setStartingDate(startDateFormattedForCurrentMonth);
      setEndingDate(endDateFormattedForCurrentMonth);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  const handlepdf = (rows) => {
    selectData[currentPage] = rows.map((x) => x.original.Id);
    const selectedCustomerCheckboxIDs =
      selectData.length > 0 ? selectData[currentPage].toString() : "";
    // console.log("Enyer", selectedCustomerCheckboxs);
    axios
      .get(
        `${config.customersBaseUrl}/customers/customerdetailforlabel?id=${selectedCustomerCheckboxIDs}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        const doc = new jsPDF();

        let position = 0;
        for (let i = 0; i < res.data.ResponseData.length; i++) {
          console.log(res.data.ResponseData.length);
          position = position + 10;
          doc.setFontSize(10);

          doc.text(
            `FirstName: ${res.data.ResponseData[i].FirstName}`,
            10,
            position
          );
          position = position + 10;
          doc.text(
            `LastName: ${res.data.ResponseData[i].LastName}`,
            10,
            position
          );
          position = position + 10;
          doc.text(`Email: ${res.data.ResponseData[i].Email}`, 10, position);
          position = position + 10;
          doc.text(`City: ${res.data.ResponseData[i].City}`, 10, position);
          position = position + 10;
          doc.text(
            `Address1: ${res.data.ResponseData[i].Address1}`,
            10,
            position
          );
          console.log(res.data.ResponseData);

          position = position + 10;

          if ((i + 1) % 4 == 0) {
            doc.addPage();
            position = 0;
          } else if (i == res.data.ResponseData.length - 1) {
          }
        }
        //   doc.deletePage(Last);
        doc.save(`Customers_mailing_label${Date.now()}.pdf`);
        setState({ data: res.data.ResponseData });
      });
  };

  const handlebarcode = (rows) => {
    selectData[currentPage] = rows.map((x) => x.original.Id);
    const selectedCustomerCheckboxIDs =
      selectData.length > 0 ? selectData[currentPage].toString() : "";

    const barcodeRequestParam = { id: selectedCustomerCheckboxIDs };
    //   Barcode_Id: pID,
    // };
    localStorage.setItem(
      "BarcodeRequestParam",
      // JSONbarcodeRequestParam
      JSON.stringify(barcodeRequestParam)
    );

    getCustomerDetailsForLabelById(barcodeRequestParam);
  };

  // const handlebarcodesheets=(rows)=>{
  //   selectData[currentPage] = rows.map((x) => x.original.Id);
  //   const selectedCustomerCheckboxIDs =
  //     selectData.length > 0 ? selectData[currentPage].toString() : "";

  //   const barcodeRequestParam = selectedCustomerCheckboxIDs;
  //   //   Barcode_Id: pID,
  //   // };
  //   localStorage.setItem(
  //     "BarcodeRequestParam",
  //     barcodeRequestParam
  //     // JSON.stringify(barcodeRequestParam)
  //   );

  //   getCustomerDetailsForLabelById(barcodeRequestParam);
  // };

  const handlebarcodesheets = (rows) => {
    selectData[currentPage] = rows.map((x) => x.original.Id);
    const selectedCustomerCheckboxIDs =
      selectData.length > 0 ? selectData[currentPage].toString() : "";

    const barcodeRequestParam = { id: selectedCustomerCheckboxIDs };
    //   Barcode_Id: pID,
    // };
    localStorage.setItem(
      "BarcodeRequestParam",
      // barcodeRequestParam
      JSON.stringify(barcodeRequestParam)
    );

    getCustomerDetailsForLabelById(barcodeRequestParam);
  };

  // const handleDelete = (id,rows, field) => {
  //   // console.log(id, rows.map((el)=>el.original),field, "id===>");

  //   const data=rows.map((el) => el.original.Id).join(",")
  //   // console.log(rows, field, "rows==>");
  //   const deleteRequestParam = {
  //     undeletecustomersids: data,
  //   };
  //   localStorage.setItem(
  //     "DeleteRequestParam",
  //     JSON.stringify(deleteRequestParam)
  //   );
  //   setDeleteModalOpen(true)
  // };

  const handleQuickBookDownload = () => {
    if (
      startingDate === undefined ||
      (endingDate === undefined && quickBookOptions.value == 1)
    ) {
      setStartingDate("");
      setEndingDate("");
    } else if (
      startingDate === undefined ||
      (endingDate === undefined && quickBookOptions.value == 2)
    ) {
      // console.log("Undefined dates");
    } else {
      axios
        .get(
          `${
            config.customersBaseUrl
          }/customers/excelexportlisting?filtertext=${""}&startdate=${startingDate}&enddate=${endingDate}`,
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: token,
            },
          }
        )
        .then((res) => {
          // console.log("res ==> ", res.data.ResponseData);

          const data =
            res.data.ResponseData.length > 0
              ? res.data.ResponseData
              : [
                  {
                    [`Id`]: null,
                    [`Name`]: null,
                    [`Company Name`]: null,
                    [`City`]: null,
                    [`Country`]: null,
                    [`Created Date`]: null,
                    [`Customer Type`]: null,
                    [`Email`]: null,
                    [`Fax`]: null,
                    [`Mobile Number`]: null,
                    [`Opening Balance`]: null,
                    [`State`]: null,
                    [`Street`]: null,
                    [`Website`]: null,
                    [`Zip`]: null,
                    [`Phone Number`]: null,
                    [`ReSale Number`]: null,
                  },
                ];

          // Create a new workbook
          const workbook = XLSX.utils.book_new();

          // Convert the data to a worksheet
          const worksheet = XLSX.utils.json_to_sheet(data);

          // Add the worksheet to the workbook
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

          // Save the workbook as an Excel file
          XLSX.writeFile(
            workbook,
            `customer_quickbook_${startingDate}_${endingDate}.xlsx`
          );
          setLoading(false);
        })
        .catch((err) => {
          toastError(ERROR_MESSAGE);
          setLoading(false);
        });
    }
  };

  const renderRowActionMenuItems = ({ row, table }) => [
    checkUserPermission(PERMISSION_EDIT) ? (
      <MenuItem
        key="edit"
        onClick={() => navigate(`/manage-customers/${row.original.Id}`)}
      >
        Edit
      </MenuItem>
    ) : (
      ""
    ),
    checkUserPermission(PERMISSION_DELETE) ? (
      <MenuItem
        className="confirm-text"
        to="#"
        // key="delete"

        title="Delete"
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={() =>
          handleDeletePopup(
            row.original.Id,
            row.original.QuickbookID,
            "",
            "singlerowdelete",
            row.original.Openingbalance
          )
        }
      >
        Delete
      </MenuItem>
    ) : (
      ""
    ),
  ];

  const renderTopToolbarCustomActions = ({ table }) => (
    <Box
      sx={{
        display: "flex",
        gap: "1rem",
        p: "0.5rem",
        flexWrap: "wrap",
      }}
    >
      {console.log(table, "tables")}

      {/* {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                  (checkUserPermission("mark-inactive") ? (
                    <Button
                      // size="small"
                      class="btn btn-sm btn-secondary"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      onClick={() =>
                        handleDeletePopup(
                          "",
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      // startIcon={<FileDownloadIcon />}
                      variant="contained"
                    >
                      Mark InActive
                    </Button>
                  ) : (
                    " "
                  ))} */}
      {/* <Button
        size="small"
        onClick={() =>
          setPagination({ ...pagination, pageSize: totalRows })
        }
        variant="contained"
      >
        Get All Data
      </Button> */}
    </Box>
  );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content   container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h3 className="page-title">Customers</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Customers List</li>
              </ul>
              {/* </div> */}
            </div>
          </div>

          <div className="d-flex" style={{ width: "100%" }}>
            <div className="d-flex mb-2" style={{ width: "100%" }}>
              {/* <div
                className="p-1 col-lg-2 col-md-6 col-sm-12 mt-3
                   "
              >
                <input
                  type="search"
                  placeholder="Search..."
                  className="search-btn form-control form-control-sm w-100 pull-right"
                  onChange={ChangeFilterText}
                  value={searchtext}
                />
              </div> */}
              <div className="p-1 col-md-3 mt-3">
                <Select
                  defaultValue={quickBookOptions}
                  onChange={(event) => {
                    handleQuickBookChange("ExcelExport", event);
                  }}
                  options={options}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  // isClearable={true}
                  // hideSelectedOptions={true}
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  id="ExcelExport"
                  name="ExcelExport"
                  className="custom-search-select"
                />
              </div>
              {quickBookOptions?.value == 2 && (
                <>
                  <div className="col-lg-2 col-md-6 col-sm-12 ml-2">
                    Start Date:
                    {/* <Flatpickr
                      type="date"
                      className="form-control form-control-sm"
                      id="StartDate"
                      name="StartDate"
                         value={
                      moment(customStartingDate).format(
                        "YYYY-MM-DDT00:00:00.000"
                      ) + "Z"
                    }
                      onChange={(event) =>
                        handleChangeCustomStartingDate(event)
                      }
                      options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    /> */}
                    <CommonDatePicker
                      FinalDate={customStartingDate}
                      handleDateChange={handleChangeCustomStartingDate}
                    />
                  </div>

                  <div className="col-lg-2 col-md-6 col-sm-12 ml-2">
                    End Date:
                    {/* <Flatpickr
                      type="date"
                      className="form-control form-control-sm"
                      id="EndDate"
                      name="EndDate"
                         value={
                      moment(customEndingDate).format(
                        "YYYY-MM-DDT00:00:00.000"
                      ) + "Z"
                    }
                      onChange={(event) => handleChangeCustomEndingDate(event)}
                      options={{
                        dateFormat: "m/d/Y",
                        altInput: true,
                        altFormat: "m/d/Y",
                      }}
                    /> */}
                    <CommonDatePicker
                      FinalDate={customEndingDate}
                      handleDateChange={handleChangeCustomEndingDate}
                    />
                  </div>
                  <div className="p-1 col-lg-1 col-md-6 col-sm-12 mt-3 ml-2">
                    <button
                      className="btn btn-dark btn-sm"
                      onClick={() => handleSearchAccordingToDate()}
                    >
                      Search
                    </button>
                  </div>
                </>
              )}
            </div>

            <div className="d-flex">
              {checkUserPermission("export-button") ? (
                <div className="mb-3" style={{ marginTop: "24px" }}>
                  <button
                    style={{ marginLeft: "12px", width: "max-content" }}
                    // style={{marginLeft : "18px"}}
                    className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                    onClick={() => handleQuickBookDownload()}
                    title="Export to excel for quickbook"
                    // style={{"padding":"6px 6px", fontSize:"15px"}}
                  >
                    Export All
                  </button>
                </div>
              ) : (
                ""
              )}
              <div style={{ marginTop: "24px" }}>
                {checkUserPermission("export-button") ? (
                  <button
                    // className="btn btn-added pull-right"
                    className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                    style={{ width: "max-content" }}
                    onClick={() => onBtExport([], "AllData")}
                  >
                    <i
                      className="fa fa-download mr-2"
                      style={{ color: "#111930" }}
                    ></i>
                    Export Visible Column
                    {/* <i class="fa-thin fa-download"></i> */}
                  </button>
                ) : (
                  ""
                )}
              </div>
              <div style={{ marginTop: "19px" }}>
                {checkUserPermission(PERMISSION_ADD) ? (
                  <Link
                    to="/manage-customers"
                    // className="btn btn-added pull-right"
                    className="btn btn-primary btn-sm pull-right mt-1"
                    style={{ width: "max-content" }}
                  >
                    <i
                      className="fa fa-plus me-2 lg"
                      style={{ color: "white" }}
                    ></i>
                    New Customer
                  </Link>
                ) : (
                  ""
                )}
              </div>
              <div
                className="btn-group-sm pull-right ms-2"
                style={{ marginTop: "19px" }}
              >
                <button
                  type="button"
                  className="btn btn-outline-dark d-none mt-1"
                >
                  More
                </button>

                {checkUserPermission(PERMISSION_CUSTOMER_INTAKE_FORM) ||
                // checkUserPermission(PERMISSION_EXCEL_IMPORT) ||
                checkUserPermission(PERMISSION_EXCEL_EXPORT) ||
                // checkUserPermission(PERMISSION_MANAGE_DELETED_CUSTOMERS) ||
                checkUserPermission(PERMISSION_CLEANUP_OLD_CUSTOMERS) ? (
                  //|| checkUserPermission(PERMISSION_CUSTOM_FIELD_CONFIGURATION)
                  <button
                    type="button"
                    className="btn btn-outline-primary dropdown-toggle me-1  mt-1"
                    data-bs-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    style={{ borderRadius: "5px" }}
                  >
                    More &nbsp;
                  </button>
                ) : (
                  " "
                )}

                <div className="dropdown-menu">
                  {/* <li>
                    {checkUserPermission(PERMISSION_CUSTOMER_INTAKE_FORM) ? (
                      <Link class="dropdown-item" to="/customer-intake-form">
                        Customer Intake Form
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>      */}

                  {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 2217-2226
                  <li>
                    {checkUserPermission(PERMISSION_EXCEL_IMPORT) ? (
                      <Link class="dropdown-item" to="/import-excel-customers">
                        Excel Import
                      </Link>
                    ) : (
                      ""
                    )}
                  </li> */}
                  {/* <li>
                    {checkUserPermission(PERMISSION_EXCEL_EXPORT) ? (
                      <Link class="dropdown-item" onClick={handleExcelExport}>
                        Excel Export
                      </Link>
                    ) : (
                      ""
                    )}
                  </li> */}
                  {/* 
                  #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 2217-2226
                  <li>
                    {checkUserPermission(
                      PERMISSION_MANAGE_DELETED_CUSTOMERS
                    ) ? (
                      <Link class="dropdown-item" to="/deleted-customers">
                        Manage Deleted Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li> */}
                  <li>
                    {checkUserPermission(PERMISSION_CLEANUP_OLD_CUSTOMERS) ? (
                      <Link
                        to="#"
                        title="Cleanup old Customers"
                        className="dropdown-item"
                        data-bs-toggle="modal"
                        data-bs-target="#CleanupConfirmationModal"
                      >
                        Cleanup old Customers
                      </Link>
                    ) : (
                      ""
                    )}
                  </li>
                  {/* #27052024HideSection #Comment For Phase-I #HIDE-27-05-2024 #Line 1871-1886
                  <li>
                    {checkUserPermission(
                      PERMISSION_CUSTOM_FIELD_CONFIGURATION
                    ) ? (
                      <Link
                        to="/custom-field-configuration"
                        title="Custom Field Configuration"
                        className="dropdown-item"
                      >
                        Customer Custom Fields
                      </Link>
                    ) : (
                      ""
                    )}
                  </li> */}
                </div>
              </div>

              <div
                style={{ marginTop: "24px" }}
                className="cursor-pointer mr-3 col-md-2 mt-4.5 ml-2"
                onClick={() =>
                  handleSaveColumnOrder(
                    loginuserid,
                    "customers",
                    columnOrder,
                    token,
                    columnVisibility
                  )
                }
                title="Lock Your Sequence"
                // onMouseEnter={() => setIcon(ColumnOrderIconHover)}
                // onMouseLeave={() => setIcon(ColumnOrderIcon)}
              >
                <i class="fa fa-lock columnsLock fs-4"></i>
              </div>
              {/* <div className="btn-group-sm pull-right ms-2 dropdown" style={{ marginTop: "19px", marginRight: "21px" }}>
                <button
                  type="button"
                  className="btn btn-outline-primary dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                  style={{ borderRadius: "5px" }}
                >
                  <i className="fa fa-cog"></i> &nbsp;
                </button> */}
              {/* <div className="dropdown-menu">
                  {columns.map((column) =>
                    // omit Action column
                    column.name.replace(/\s+|-|\/|#/g, "") !== "Action" ? (
                      <div
                        key={column.name.replace(/\s+|-|\/|#/g, "")}
                        className="form-check ms-2 mt-1"
                      >
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                          value={column.name.replace(/\s+|-|\/|#/g, "")}
                          checked={
                            !hiddenColumns.includes(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          } 
                          onChange={() =>
                            handleCheckboxChange(
                              column.name.replace(/\s+|-|\/|#/g, "")
                            )
                          }
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`checkbox-${column.name.replace(
                            /\s+|-|\/|#/g,
                            ""
                          )}`}
                        >
                          {column.name}
                        </label>
                      </div>
                    ) : (
                      ""
                    )
                  )}
                </div>
              </div> */}
            </div>
          </div>
          <div style={{ position: "relative", zIndex: "0" }}>
            <CommonMatrialReactTableServerSideRender
              MainHeading="Sonar POS"
              ReportHeading="Customer List"
              columns={columns}
              data={data}
              // startdate={startdate}
              // enddate={enddate}
              columnGrouping={[]}
              columnsVisibility={{}}
              enableRowActions={
                checkUserPermission(PERMISSION_EDIT) ||
                checkUserPermission(PERMISSION_DELETE)
              }
              enableRowSelection={true}
              renderRowActionMenuItems={renderRowActionMenuItems}
              renderTopToolbarCustomActions={renderTopToolbarCustomActions}
              density="comfortable"
              showGlobalFilter={true}
              showColumnFilters={false}
              expanded={true}
              pagination={{ pageIndex: 0, pageSize: 25 }}
              rowCount={rowCount}
              setColumnFilters={setColumnFilters} // for termp comment filteron column
              setGlobalFilter={setGlobalFilter}
              setPagination={setPagination}
              setSorting={setSorting}
              setColumnOrder={setColumnOrder}
              setColumnVisibility={setColumnVisibility} //setColumnVisibility
              state={{
                columnFilters, // for termp comment filteron column
                // globalFilter,
                isLoading,
                pagination,
                showAlertBanner: isError,
                showProgressBars: isRefetching,
                sorting,
                columnOrder,
                columnVisibility,
              }}
            />
          </div>
          {/* <MaterialReactTable
            columns={columns}
            data={data}
            // positionPagination='top'
            enableColumnResizing
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            enableRowActions={
              checkUserPermission(PERMISSION_EDIT) ||
              checkUserPermission(PERMISSION_DELETE)
            }
            positionGlobalFilter="left"
            manualFiltering
            // enableEditing

            renderRowActionMenuItems={({ row }) => [
              checkUserPermission(PERMISSION_EDIT) ? (
                <MenuItem
                  key="edit"
                  onClick={() =>
                    navigate(`/manage-customers/${row.original.Id}`)
                  }
                >
                  Edit
                </MenuItem>
              ) : (
                ""
              ),
              checkUserPermission(PERMISSION_DELETE) ? (
                <MenuItem
                  className="confirm-text"
                  to="#"
                  // key="delete"

                  title="Delete"
                  data-bs-toggle="modal"
                  data-bs-target="#DeleteConfirmationModal"
                  onClick={() =>
                    handleDeletePopup(
                      row.original.Id,
                      row.original.QuickbookID,
                      "",
                      "singlerowdelete",
                      row.original.Openingbalance
                    )
                  }
                >
                  Delete
                </MenuItem>
              ) : (
                ""
              ),
            ]}
            renderTopToolbarCustomActions={({ table }) => (
              <Box
                sx={{
                  display: "flex",
                  gap: "1rem",
                  p: "0.5rem",
                  flexWrap: "wrap",
                }}
              >
                {console.log(table, "tables")}

                {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                checkUserPermission(PERMISSION_EMAIL_CUSTOMERS) ? (
                  !table.getIsSomeRowsSelected() &&
                  !table.getIsAllRowsSelected() ? (
                    <Button
                      size="small"
                      // disabled={
                      //   !table.getIsSomeRowsSelected() &&
                      //   !table.getIsAllRowsSelected()
                      // }
                      //only export selected rows
                      // data-bs-toggle="modal"
                      // data-bs-target="#UnDeleteConfirmationModal"
                      onClick={() =>
                        handleCustomerEmails(
                          "",
                          table.getSelectedRowModel().rows,
                          "multipleRowInactive"
                        )
                      }
                      startIcon={<EmailIcon />}
                      variant="contained"
                    >
                      E-mail
                    </Button>
                  ) : (
                    <a href={"mailto:" + selectedCustomerCheckEmails}>
                      <Button
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        // size="small"
                        // disabled={
                        //   !table.getIsSomeRowsSelected() &&
                        //   !table.getIsAllRowsSelected()
                        // }
                        //only export selected rows
                        // data-bs-toggle="modal"
                        // data-bs-target="#UnDeleteConfirmationModal"
                        onClick={() =>
                          handleCustomerEmails(
                            "",
                            table.getSelectedRowModel().rows,
                            "multipleRowInactive"
                          )
                        }
                        startIcon={<EmailIcon />}
                        variant="contained"
                      >
                        E-mail
                      </Button>
                    </a>
                  )
                ) : (
                  ""
                )}

                {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                checkUserPermission(PERMISSION_MAILING_LABELS) ? (
                  <Button
                    class="btn btn-sm btn-secondary"
                    style={{ display: "flex" }}
                    // size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    // data-bs-toggle="modal"
                    // data-bs-target="#UnDeleteConfirmationModal"
                    onClick={() => handlepdf(table.getSelectedRowModel().rows)}
                    startIcon={<EmailIcon />}
                    variant="contained"
                  >
                    Mailing-Labels
                  </Button>
                ) : (
                  ""
                )}

                {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                checkUserPermission(PERMISSION_BARCODE_LABELS) ? (
                  !table.getIsSomeRowsSelected() &&
                  !table.getIsAllRowsSelected() ? (
                    <Button
                      size="small"
                      disabled={
                        !table.getIsSomeRowsSelected() &&
                        !table.getIsAllRowsSelected()
                      }
                      //only export selected rows
                      // data-bs-toggle="modal"
                      // data-bs-target="#UnDeleteConfirmationModal"
                      onClick={() =>
                        handlebarcode(table.getSelectedRowModel().rows)
                      }
                      startIcon={<MailOutlineIcon />}
                      variant="contained"
                    >
                      Barcode Labels
                    </Button>
                  ) : (
                    // <a href={"/customer-barcode-label"}>
                    <NavLink to="/customer-barcode-label">
                      <Button
                        class="btn btn-sm btn-secondary"
                        style={{ display: "flex" }}
                        // size="small"
                        // disabled={
                        //   !table.getIsSomeRowsSelected() &&
                        //   !table.getIsAllRowsSelected()
                        // }
                        //only export selected rows
                        // data-bs-toggle="modal"
                        // data-bs-target="#UnDeleteConfirmationModal"
                        onClick={() =>
                          handlebarcode(table.getSelectedRowModel().rows)
                        }
                        startIcon={<MailOutlineIcon />}
                        variant="contained"
                      >
                        Barcode Labels
                      </Button>
                    </NavLink>
                    // {/* </a> */}
          {/* )
                ) : (
                  ""
                )}

                {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                checkUserPermission(PERMISSION_BARCODE_SHEETS) ? (
                  // <a href={"/customer-barcode-label"}>
                  <Button
                    class="btn btn-sm btn-secondary"
                    style={{ display: "flex" }}
                    // size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    //only export selected rows
                    data-bs-toggle="modal"
                    data-bs-target="#BarcodeSheetModal"
                    title="MailingLabels"
                    onClick={() =>
                      handlebarcodesheets(table.getSelectedRowModel().rows)
                    }
                    startIcon={<MailOutlineIcon />}
                    variant="contained"
                  >
                    Barcode-Sheets
                  </Button>
                ) : (
                  // </a>
                  ""
                )} */}

          {/* 
                {(table.getIsSomeRowsSelected() ||
                  table.getIsAllRowsSelected()) &&
                checkUserPermission(PERMISSION_DELETE) ? (
                  <Button
                    class="btn btn-sm btn-secondary"
                    style={{ display:"flex"}}
                    // size="small"
                    disabled={
                      !table.getIsSomeRowsSelected() &&
                      !table.getIsAllRowsSelected()
                    }
                    onClick={() =>
                      handleDeletePopup(
                        "",
                        "",
                        table.getSelectedRowModel().rows,
                        "multipleRowInactive",
                        ""
                      )
                    }
                    startIcon={<DeleteIcon />}
                    variant="contained"
                  >
                    Delete Selected
                  </Button>
                ) : (
                  ""
                )} */}

          {/* <Button
                  size="small"
                  onClick={() =>
                    // setPagination({ ...pagination, pageSize: totalRows })
                    setPagination({
                      ...pagination,
                      pageIndex: 0,
                      pageSize: totalRows,
                    })
                  }
                  variant="contained"
                >
                  Get All Data
                </Button> */}
          {/* </Box>
            )}
            rowVirtualizerOptions={{
              overscan: 10, //adjust the number or rows that are rendered above and below the visible area of the table
              estimateSize: () => 100, //if your rows are taller than normal, try tweaking this value to make scrollbar size more accurate
            }}
            muiTableContainerProps={{
              sx: { maxHeight: "fit-content" },
            }}
            initialState={{
              density: "comfortable",
              showGlobalFilter: true,
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 10 },
              // sorting: { id: "Name", desc: false }, //sort by state by default
              columnVisibility: {
                Email: false,
                Image: false,
                IsEcommerceUser: false,
                Openingbalance: false,
              },
            }}
            //For color of each alternative row(Zebra-column)
            muiTableBodyProps={{
              sx: () => ({
                "& tr:nth-of-type(even)": {
                  backgroundColor: "var(--datatable-row-background-color)",
                  //'rgb(237 237 233 / 63%)'
                },
                "& td": {
                  borderRight:
                    "1px solid var(--datatable-row-background-hover-color)",
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },

                "& tr": {
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },
              }),
            }}
            muiPaginationProps={{
              rowsPerPageOptions: [10, 25, 50, 100, 300],
            }}
            // For providing color to header of table
            muiTableHeadCellProps={{
              sx: (theme) => ({
                background: "var(--datatable-row-background-color)", //'#e9e9e9',
                borderRight:
                  "1px solid var(--datatable-row-background-hover-color)",
                lineHeight: "16px",
                fontWeight: "500",
                fontSize: "14px",
                color: "var(--primary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              // isError
              // ? {
              //   color: "error",
              //   children: "Error loading data",
              // }
              // : undefined
              {
                isError: () => ({
                  color: "error",
                  children: "Error loading data",
                }),
                sx: (theme) => ({
                  background: "var(--datatable-row-background-color)", //'#e9e9e9',
                  lineHeight: "16px",
                  fontWeight: "500",
                  fontSize: "14px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                }),
              }
            }
            muiSelectCheckboxProps={{
              sx: (theme) => ({
                lineHeight: "16px",
                fontWeight: "400",
                fontSize: "12px",
                color: "var(--prinary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            muiSelectAllCheckboxProps={{
              sx: (theme) => ({
                lineHeight: "16px",
                fontWeight: "400",
                fontSize: "12px",
                color: "var(--prinary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            onColumnFiltersChange={setColumnFilters} // for termp comment filteron column
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={rowCount}
            // enableColumnVirtualization={false}
            // enableColumnVirtualization
            state={{
              // columnFilters, // for termp comment filteron column
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          /> */}
        </div>
      </div>

      {/* Delete Model  */}

      <DeleteConfirmationModal
        deleteApiUrl={`${config.customersBaseUrl}/customers/delete`}
        open={deleteModalOpen}
        onClose={() => setDeleteModalOpen(false)}
        openingbalance={openingbalance}
      />

      {/* {/* Cleanup old customer */}
      <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.customersBaseUrl}/customers/cleanupcustomer`}
      />

      <SkipbarcodeConfirmationModal
      // CleanupConformationApiUrl={`${config.customersBaseUrl}/customers/cleanupcustomer`}
      // onClick={handlebarcodesheet(selectedCustomerCheckboxs)}
      // onClick={window.location.reload()}
      />
    </>
  );
};

export default Customers;
